var map = {
	"./abc_curve/eye.png": "9ea5",
	"./calendar_icon.svg": "90c1",
	"./context_selector_arrow.svg": "f5d7",
	"./decrement_arrow.svg": "885e",
	"./dock_icon.svg": "7ef7",
	"./dropdown_arrow.svg": "6bb5",
	"./dropdown_arrow_green.svg": "2566",
	"./increment_arrow.svg": "a363",
	"./info-circle.svg": "bc73",
	"./logo-google-analytics.svg": "eb33",
	"./no_data_icon.svg": "afc2",
	"./origin_icon.svg": "a389",
	"./pencil.svg": "33bf",
	"./period/billet_icon.svg": "d705",
	"./period/cart_icon.svg": "44cb",
	"./period/conversion_rate.svg": "31c1",
	"./period/desktop_icon.svg": "0a1f",
	"./period/desktop_v2.svg": "fba6",
	"./period/filter_01_icon.svg": "004f",
	"./period/mobile_icon.svg": "f40c",
	"./period/mobile_v2.svg": "ae05",
	"./period/new_customers.svg": "8e18",
	"./period/new_customers_orders.svg": "2a54",
	"./period/orders.svg": "50fd",
	"./period/pix_icon.svg": "897b",
	"./period/real_conversion_rate.svg": "aa8f",
	"./period/recurrent_customers.svg": "808c",
	"./period/total_bucket_card.svg": "8049",
	"./period/visitors.svg": "d31b",
	"./period/wallet_v2.svg": "5f3e",
	"./period_icon.svg": "a676",
	"./sales/active_button_arrow.svg": "ba78",
	"./select_arrow.svg": "b72f",
	"./shippings/billed_value.svg": "e88d",
	"./shippings/customer_shipping_paid.svg": "8c03",
	"./shippings/dispatched_orders.svg": "9f19",
	"./shoppub_logo_v2.svg": "29ce",
	"./shoppub_logo_v3.svg": "4227",
	"./stock/items.svg": "8c58",
	"./stock/minimum_stock.svg": "3902",
	"./stock/no_stock.svg": "d3af",
	"./stock/skus.svg": "9274",
	"./ticket.svg": "ba2d",
	"./ticket_progression/avg_ticket_progression.svg": "e509",
	"./ticket_progression/max_ticket.svg": "ba3c",
	"./ticket_progression/min_ticket.svg": "057b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";